import * as React from "react";
const SvgIcCard = props => <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path fillRule="evenodd" clipRule="evenodd" d="M1 21H23V3H1V21ZM20 18H4V12H20V18ZM20 8H4V6H20V8Z" fill="currentColor" /></svg>;
export default SvgIcCard;